<section class="icon-container">
    <div (click)="openCamera()" (keydown)="openCameraOnKeyDown($event)" class="icon-cel">
        <mat-icon>add_a_photo</mat-icon>
    </div>
    <div (click)="openGalery()" (keydown)="openGaleryOnKeyDown($event)" class="icon-cel">
        <mat-icon>add_photo_alternate</mat-icon>
    </div>
</section>